import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { translate } from 'react-i18next';
import PagesLayout from './PagesLayout';

const MajakLink = ({ t }) => <Link to="/">{t('Majak.sk')}</Link>;
const MajakLinkT = translate()(MajakLink);

const Vyhody = ({ t }) => (
  <PagesLayout className="vyhody">
    <h2>{t('Výhody Majak.sk')}</h2>
    <p>
      {t('Výhody')} <MajakLinkT /> {t('môžu využiť dva typy ľudí:')}
    </p>
    <ol className="numbered-blue" type="1">
      <li>
        <strong>{t('investori, ktorí si chcú zhodnotiť svoje úspory')}</strong>
        <br />
        {t('vyššou sadzbou, než je ponúkaná finančnými ústavmi')}
      </li>
      <li>
        <strong>{t('ľudia, ktorí si chcú požičať')}</strong>
        <br />
        {t('výhodnejšie ako im ponúkajú finančné ústavy')}
      </li>
    </ol>
    <p>
      {t('Vhodným riešením pre obe tieto skupiny je')} <MajakLinkT />.{' '}
      {t(
        'Základný princíp je v požičiavaní peňazí od investorov, ktorí ich majú navyše, k dlžníkom, ktorým peniaze naopak chýbajú, pričom jeden investor môže požičať peniaze naraz niekoľkým dlžníkom, čím sa diverzifikuje riziko nesplatenia úveru alebo jeho časti niektorým z dlžníkov. Nejde o vzťah medzi jedným investorom a jedným dlžníkom, ale o vzťah medzi jedným investorom a viacerými dlžníkmi. Ide o komunitné investovanie alebo kolektívne požičiavanie.'
      )}
    </p>
    <p>
      {t('Všetko vybavíte rýchlo, pohodlne a cez internet. Úroky na pôžičkách získaných cez')}{' '}
      <MajakLinkT />{' '}
      {t(
        'sú výrazne nižšie ako sú úroky pri spotrebiteľských úrokoch v bankách a v tzv. nebankovkách. Cez'
      )}{' '}
      <MajakLinkT />{' '}
      {t(
        'Vám požičiava priamo Investor. A to bez účasti banky, ktorá si účtuje množstvo poplatkov, ako napr. administratívny poplatok, poplatok za vedenie účtu a pod. A tieto poplatky pri pôžičkách uzatvorených cez'
      )}{' '}
      <MajakLinkT /> {t('odpadávajú.')}
    </p>
  </PagesLayout>
);

Vyhody.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate()(Vyhody);



// WEBPACK FOOTER //
// ./src/features/pages/Vyhody.js